export default "__VITE_ASSET__DCoVY3Y$__"